




























































import BaseComponent from '@/components/base-component.vue';
import DoctorForm from '@/components/doctors/doctor-form.vue';
import UiAutocompleClientsSubsidiaries from '@/components/UI/autocomplete-clients-subsidiaries.vue';
import CollapsibleCard from '@/components/UI/collapsible-card.vue';
import LockChildren from '@/components/UI/lock-children.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiSelectDoctor from '@/components/UI/select-doctors.vue';
import IDoctor from '@/interfaces/doctor';
import { PrescricaoParmDTO } from '@/interfaces/prescription';
import { TranscricaoOcrResult } from '@/interfaces/transcricao-ocr';
import DoctorModel from '@/models/doctor-model';
import { checkUserPermissions } from '@/services/auth';
import * as service from '@/services/doctors';
import { getClientUnitPrescription, getHealthInsuranceByClient } from '@/services/prescription';
import { getLocalUser } from '@/services/session-data';
import { PERMISSIONS_KEYS } from '@/settings/consts/permissions';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';



@Component({
  components: {
    PermissionAuth,
    CollapsibleCard,
    UiAutocompleClientsSubsidiaries,
    UiSelectDoctor,
    LockChildren,
    DoctorForm,
  },
})
export default class PrescriptionFormClient extends BaseComponent {
  @Prop()
  public item: any;
  @Prop()
  public copyItem: any;
  @Prop()
  public disabled?: boolean;
  @Prop()
  public lockClient?: boolean;
  @Prop()
  public ocr: TranscricaoOcrResult;
  @Prop()
  public draft: PrescricaoParmDTO;

  public formDoctorOpen: boolean = false;
  public doctor: DoctorModel = new DoctorModel();

  public alertTitle: string = 'Alterar Cliente?';
  public alertMessage: string =
    'Ao alterar, as informações da prescrição serão perdidas.';

  public clientLocked: boolean = false;

  public healthInsurance: any[] = [];
  healthInsuranceLoading = false;

  public rules: any = {
    client: [(v) => (!!v && !!v.id) || 'Selecione um cliente'],
    doctor: [(v) => (!!v && !!v.id) || 'Selecione um médico'],
  };

  public doctorLoading: boolean = false;
  public doctors: IDoctor[] = [];

  @Watch('item')
  public onChangeItem(item: any) {
    if (!this.disabled && item && item.unidade && item.unidade.id) {
      this.item.unidade = { id: item.unidade.id };
  +   this.onChangeClient();
    }
  }

  @Watch('lockClient')
  public onChangeLockClient(val: boolean): void {
    this.clientLocked = val;
  }

  @Watch('clientLocked')
  public onChangeClientLocked(val: boolean): void {
    if (!!val) {
      return;
    }
    this.$emit('unlockClient');
  }

  @Watch('ocr')
  public onChangeOcr(ocr: TranscricaoOcrResult): void {
    if (!ocr || !ocr.idUnidade) {
      return;
    }
    if (!this.item.unidade || this.item.unidade.id != ocr.idUnidade) {      
      this.item.unidade = { id: ocr.idUnidade };
      this.onChangeClient();
    }

    if (ocr.idMedico) {
      this.setDoctorWhenReady(ocr.idMedico);
    }
  }

  @Watch('draft')
  public onDraftChange(draft: PrescricaoParmDTO): void {    
    if (!draft || !draft.idUnidCliente) {
      return;
    }
    this.item.unidade = { id: draft.idUnidCliente };
    this.onChangeClient();

    if (draft.idMedico) {
      this.setDoctorWhenReady(draft.idMedico);
    }
    if (draft.idConvenio) {
      this.setHealthInsuranceWhenReady(draft.idConvenio);
    }
  }

  @Watch('copyItem')
  public onChangeCopyItem(copyItem): void {
    if (!copyItem || !copyItem.unidade || !copyItem.unidade.id) {
      return;
    }
    this.item.unidade = { id: copyItem.unidade.id };
    this.onChangeClient();

    if (copyItem.medico && copyItem.medico.id) {
      this.setDoctorWhenReady(copyItem.medico.id);
    }
  }

  private setDoctorWhenReady(idDoctor) {
    this.sleepUntil(() => {
      return this.doctors && this.doctors.length;
    }, 180000).then(() => {
      this.item.medico = this.doctors.find((p) => Number(p.id) == idDoctor);
      this.onChangeDoctor(this.item.medico);
    });
  }

  private setHealthInsuranceWhenReady(idConvenio) {
    this.sleepUntil(() => {
      return this.healthInsurance && this.healthInsurance.length;
    }, 180000).then(() => {
      this.item.convenio = this.healthInsurance.find((p) => Number(p.id) == idConvenio);
    });
  }

  public showDoctorSelect(): boolean {
    return !this.isDoctor();
  }

  public onChangeDoctor(val): void {
    this.$emit('changeDoctor', val);
  }

  public onChangeClient(): void {
    this.getDoctors();
    this.getHealthInsurance();
    this.$emit('changeClient');
    if (this.item.unidade && this.item.unidade.id) {
      this.addSubsc(
        getClientUnitPrescription(this.item.unidade.id).subscribe((c) => {
          this.item.unidade = c;
        }),
      );
    }
  }

  public newDoctor(): void {
    this.doctor = new DoctorModel();
    this.formDoctorOpen = true;
  }

  get showNewDoctorButton(): boolean {
    return (
      checkUserPermissions([PERMISSIONS_KEYS.DOCTOR_INSERT]) &&
      !this.disabled &&
      !!this.item.unidade &&
      this.item.unidade.cliente
    );
  }

  public closeDoctorForm(): void {
    this.doctor = new DoctorModel();
    this.formDoctorOpen = false;
  }

  public saveDoctorItem(doctor: DoctorModel): void {
    this.closeDoctorForm();
    if (!!this.item.unidade) {
      if (
        !!doctor &&
        doctor.unidadesCliente.some((item) => item.id === this.item.unidade.id)
      ) {
        this.getDoctors().then(() => {
          const newDoctor = this.doctors.find((p) => p.id == doctor.id);
          this.item.medico = newDoctor;
        });
      }
    }
  }

  public getDoctors(): Promise<void> {
    this.doctors = [];

    const currentDoctor = this.item.medico;

    if (!this.item.isVisualization() && !this.item.isCopy()) {
      this.item.medico = new DoctorModel();
    }

    return new Promise((res, rej) => {
      if (!this.item.unidade || !this.item.unidade.id) {
        res();
        return;
      }

      if (this.isDoctor()) {
        getLocalUser().subscribe((currentUser) => {
          res();
          this.item.medico = new DoctorModel(currentUser);
        });
      }

      if (
        this.item.isModel() ||
        this.item.isCopy() ||
        this.item.isVisualization() ||
        this.isDoctor()
      ) {
        this.doctors.push(this.item.medico);
      } else {
        this.doctorLoading = true;

        service.getClientDoctors(this.item.unidade.id).subscribe(
          (data) => {
            this.doctorLoading = false;
            this.doctors = data;

            if (!!currentDoctor) {
              this.item.medico = this.doctors.find(
                (doctor) => doctor.id === currentDoctor.id,
              );
            }
            res();
          },
          () => {
            this.doctorLoading = false;
            rej();
          },
        );
      }
    });
  }

  private getHealthInsurance(): void {
    this.healthInsurance = [];

    if (!this.item.unidade || !this.item.unidade.id) {
      return;
    }

    if (
      !!this.item.paciente &&
      (this.item.isCopy() || this.item.isVisualization())
    ) {
      this.healthInsurance.push(this.item.paciente.convenio);
    } else {
      this.healthInsuranceLoading = true;
        getHealthInsuranceByClient(this.item.unidade.id)
        .subscribe((data) => {
          this.healthInsuranceLoading = false;
          this.healthInsurance = data;
        }, error => {
          this.healthInsuranceLoading = false;
        });
    }
  }
}
